<template>
  <div>
    <gg-card>
      <gg-card-header>
        Installation Status
      </gg-card-header>
      <gg-card-text>
        <v-data-table :headers="headers" :items="items" :footer-props="{ itemsPerPageOptions: this.pagination }">
          <template slot="item" slot-scope="props">
            <tr>
              <td>{{ props.item.domain }}</td>
              <td>
                <v-icon small class="pb-1" :color="statusColor(props.item.status)">mdi-circle</v-icon>
                {{ props.item.status }}
              </td>
              <td>
                <gg-btn text v-if="props.item.status === 'Installed'"
                       :loading="loading"
                       :disabled="loading"
                       @click="setUninstallSsl({ id, domain: props.item.domain })">Uninstall</gg-btn>
                <gg-btn text v-else
                       :loading="loading"
                       :disabled="loading"
                       @click="setInstallSsl({ id, domain: props.item.domain })">Install</gg-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor } from '@/helpers/helpers'

export default {
  name: 'InstallationStatus',
  data: () => ({
    headers: [
      {
        text: 'Domain',
        value: 'domain',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'domain',
        sortable: false,
      }
    ],
    loading: false
  }),
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions(['installSsl', 'uninstallSsl', 'reportSuccess', 'reportError']),
    async setInstallSsl (id, domain) {
      try {
        this.loading = true
        await this.installSsl(id, domain)
        this.loading = false
        this.reportSuccess('Certificate was successfully installed')
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    async setUninstallSsl (id, domain) {
      try {
        this.loading = true
        await this.uninstallSsl(id, domain)
        this.loading = false
        this.reportSuccess('Certificate was successfully uninstalled')
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    statusColor,
  },
  computed: {
    ...mapGetters(['ssl_installs', 'pagination']),
    items () {
      if (!this.ssl_installs) {
        return []
      }
      return Object.keys(this.ssl_installs).reduce((carry, domain) => {
        carry.push({
          domain,
          status: this.ssl_installs[domain],
        })
        return carry
      }, [])
    }
  },
}
</script>
